import React, { useState, useCallback, useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Link, useHistory } from "react-router-dom";
import AutoWidthSwiper from "../../../../../../../../../components/swiper/autowidth";
import { useOrder } from "../../../../../../../hook/order";
import { TOTAL_STATUS_UNPAID } from "../../../../../../../utils/constant";


export default props =>{
    useStyles(cls);
    const { orderItem, orderProducts, isReturn } = props;

    const { getPayUrl } = useOrder(orderItem);
    const history = useHistory();
    const [show, setShow] = useState(true);

    const handleTransitionEnd = useCallback((swiper) =>{
        setShow(!swiper?.isEnd);
    }, []);

    const lastOrderItems = useMemo(() =>{
        if(orderProducts?.length > 4){
            let length = orderProducts.length - 1;
            return orderProducts[length]
        }
    }, [orderItem]);

    const toOrderClickDetail = useCallback((evt) =>{
        evt.preventDefault();
        if(orderItem?.fulfillmentStatus === TOTAL_STATUS_UNPAID){
            // if(!getPayUrl){
            //     window.location.href = `/checkout/${orderItem?.id}`;
            // }else{
            //     window.location.href = getPayUrl;
            // }
            window.location.href = `/checkout/${orderItem?.id}`;
        }else {
            if(isReturn){
                history.push(`/user/order/return-detail/${orderItem?.id}`);
            }else{
                history.push(`/user/order/detail/${orderItem?.id}`);
            }
        }
    }, [orderItem, isReturn, getPayUrl]);

    return <div className={cls.OrderItemProductImages}>
        <a className={cls.SkipLink} onClick={toOrderClickDetail}>
            <div className={cls.ImageContainer}>
                <div className={cls.SwiperContainer}>
                    <AutoWidthSwiper
                        items={orderProducts}
                        options={{
                            slidesPerView: 'auto',
                            spaceBetween : 10,
                            onTransitionEnd:handleTransitionEnd
                        }}
                        render={(item, index) =>{
                            return <div className={cls.ImageItem} key={index}>
                                <img src={item?.productImageUrl} alt="ORDER IMAGE" />
                                {
                                    item?.isPreOrder && <span className={cls.PreOrder}>Pre order</span>
                                }
                            </div>
                        }}
                    />
                </div>

                <div className={cls.ViewMore} style={{display: `${orderProducts?.length > 4 && show ? 'block' : 'none'}`}}>
                    <div className={cls.Image}>
                        <img src={lastOrderItems?.productImageUrl} alt={lastOrderItems?.productName} />
                    </div>

                    <div className={cls.Mask}></div>
                    <span className={cls.Number}>+{orderProducts?.length - 4}</span>
                </div>
            </div>
        </a>
    </div>
}